import { api } from '@/lib/api/client'
import type { CodeOption } from '@/features/merchants/types/merchant'

/** `GET /countries` lists ISO 3166-1 alpha-2 countries, sorted by their name in `locale`. */
export async function getCountries(locale?: string): Promise<CodeOption[]> {
  const { data } = await api.get<{ data: CodeOption[] }>('/countries', { params: { locale } })

  return data.data
}
